import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

interface SriErrorModalProps {
    isOpen: boolean;
    toggle: () => void;
    status: string;
    errors: Array<{
        type: string;
        message: string;
        additionalInfo?: string;
    }>;
}

const SriErrorModal: React.FC<SriErrorModalProps> = ({
    isOpen,
    toggle,
    status,
    errors
}) => {
    const getModalTitle = () => {
        if (status === 'UNAUTHORIZED') return ' Errores del SRI - Guía No Autorizada';
        return 'Información del SRI';
    };

    const getModalColor = () => {
        if (status === 'UNAUTHORIZED') return 'danger';
        return 'warning';
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg" centered>
            <ModalHeader 
                toggle={toggle} 
                className={`bg-soft-${getModalColor()}`}
            >
                {getModalTitle()}
            </ModalHeader>
            <ModalBody>
                <div className="mb-3">
                    <strong>Estado de la guía:</strong> 
                    <span className={`badge bg-${getModalColor()} ms-2`}>
                        {status}
                    </span>
                </div>

                {errors.length > 0 ? (
                    <div>
                        <h6 className="text-muted mb-3">Detalles del error:</h6>
                        {errors.map((error, index) => (
                            <div key={index} className={`alert alert-${getModalColor()} mb-2`}>
                                <div className="d-flex align-items-start">
                                    <i className={`ri-error-warning-fill me-2`}></i>
                                    <div className="flex-grow-1">
                                        <strong>Tipo:</strong> {error.type}<br />
                                        <strong>Mensaje:</strong> {error.message}<br />
                                        {error.additionalInfo && (
                                            <>
                                                <strong>Información adicional:</strong><br />
                                                <small>{error.additionalInfo}</small>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="alert alert-info">
                        <div className="d-flex align-items-start">
                            <i className="ri-information-line me-2"></i>
                            <div className="flex-grow-1">
                                <strong>INFORMACIÓN</strong><br />
                                Estado: {status}<br />
                                <small>Revisa el estado de esta guía en el portal del SRI para más detalles.</small>
                            </div>
                        </div>
                    </div>
                )}

                </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>
                    Cerrar
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default SriErrorModal;
